<script lang="ts" setup>
import { watch } from 'vue'
import { useTitle } from '@vueuse/core'
import { useGlobalStore } from '@/store/global.ts'
import { useAuthStore } from '@/store/auth'
import { usePendo } from '@/composables/usePendo'
import { env } from '@/utilities/env'

const authStore = useAuthStore()
const globalStore = useGlobalStore()

useTitle('Country Allocation')

if (env('VITE_ENABLE_PENDO')?.toLowerCase() === 'true') {
  const pendo = usePendo()

  watch(
    () => authStore.isAuthenticated,
    isAuthenticated => {
      if (isAuthenticated && authStore.user?.username) {
        pendo.initialize({
          visitor: { id: authStore.user.username },
        })
      }
    },
    { immediate: true },
  )
}
</script>

<template>
  <VApplicationError
    v-if="globalStore.fatalError"
    :error="globalStore.fatalError || undefined"
  />
  <VApplicationLoading v-else-if="!authStore.isAuthenticated" />
  <div
    v-else
    class="bg-general-medium flex min-h-screen"
  >
    <VSidebarNav>
      <template v-slot:menu="{ collapsed }">
        <div id="sidebar-menu">
          <VSidebarNavGroup>
            <VSidebarNavHeader :collapsed="collapsed">Menu</VSidebarNavHeader>
            <VSidebarNavItem
              icon="home"
              label="Home"
              to="/"
              :collapsed="collapsed"
            />
            <VSidebarNavItem
              icon="transfer"
              label="TPER"
              to="/tper"
              :collapsed="collapsed"
            />
          </VSidebarNavGroup>
        </div>
      </template>
      <template v-slot:footer="{ collapsed }">
        <VFeedbackDialog>
          <template #activator="{ open, isOpen }">
            <VSidebarNavItem
              icon="speech"
              label="Provide Feedback"
              :collapsed
              :active="isOpen"
              @click="open"
            />
          </template>
        </VFeedbackDialog>
      </template>
      <template #default>
        <RouterView />
        <Teleport to="body">
          <VApplicationConfirm />
          <VApplicationAlert />
          <VApplicationToaster />
        </Teleport>
      </template>
    </VSidebarNav>
  </div>
</template>

<style>
body.disable-scroll {
  overflow-y: hidden;
}

body {
  color: #001a66;
  min-width: 1300px;
}
</style>
